module.exports = __webpack_public_path__ + "img/promo_mobile.a6d281ec.png";